import { render, staticRenderFns } from "./ModulePrivilegeFunctions.vue?vue&type=template&id=5847a4f1&"
import script from "./ModulePrivilegeFunctions.vue?vue&type=script&lang=js&"
export * from "./ModulePrivilegeFunctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports